import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const chevronCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default chevronCommands;
